export default [
    {
        "id": "popupBanner-1",
        "plugin": null,
        "pluginId": null,
        "name": "banner_popup1",
        "html": require('./popupBanners/popupBanner-1/html').default,
        "scss": require('./popupBanners/popupBanner-1/scss').default,
        "css": require('./popupBanners/popupBanner-1/css').default,
        "cssMobile": require('./popupBanners/popupBanner-1/cssMobile').default,
        "scssMobile": require('./popupBanners/popupBanner-1/scssMobile').default,
        "js": require('./popupBanners/popupBanner-1/js').default,
        "minJs": require('./popupBanners/popupBanner-1/minJs').default,
        "fixedView": true,
        "showArrow": false,
        "isPopup": true,
        "relatedBanner": "banner_popup1",
        "settings": "",
        "svgContent": require('./popupBanners/popupBanner-1/svgContent').default,
        "svgViewBox": "0 0 696 418"
    }
]